import Vue from 'vue';
import Vuex from 'vuex';
import profileModule from './authModule';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    profileModule,
  },
});